import { AppEnv } from "../utils/application";

export interface FeatureFlagConfig {
  feature: string;
  env: AppEnv[];
}

export const Feature = {
  MedInfo: "med-info",
  CustomTabs: "custom-tabs",
  Retros: "retros",
  DocumentSummary: "document-summary",
  RoleSwitching: "role-switching",
  StructuredData: "structured-data",
  ParentChild: "parent-child",
  PrimaryMarketResearch: "primary-market-research",
  ChatAcrossStudies: "pmr.chat-across-studies",
  PmrSwapSummaryFile: "pmr.edit.swap_summary",
};

export const featureFlagConfig: FeatureFlagConfig[] = [
  { feature: Feature.MedInfo, env: ["local"] },
  { feature: Feature.CustomTabs, env: ["all"] },
  { feature: Feature.Retros, env: ["all"] },
  { feature: Feature.DocumentSummary, env: ["local", "dev"] },
  { feature: Feature.RoleSwitching, env: ["local", "dev"] },
  { feature: Feature.StructuredData, env: ["local", "dev"] },
  { feature: Feature.ParentChild, env: ["all"] },
  { feature: Feature.PrimaryMarketResearch, env: ["all"] },
  { feature: Feature.ChatAcrossStudies, env: ["all"] },
  { feature: Feature.PmrSwapSummaryFile, env: ["all"] },
];
